module.exports = {
      id: "ic-fibonacci-fan-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#ic-fibonacci-fan-usage",
      toString: function () {
        return this.url;
      }
    }